import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import CustomisedButton from '../../components/button/button';
import CustomisedOtpInput from '../../components/otpInput/otpInput';
import ElementTitle from '../../components/title/elementTitle/elementTitle';
import { IRequestSignOtpResponse } from '../../models/customerContract.model';
import {
    GetCustomerContractTerms,
    RequestSignOtp,
    SignContractOtp,
} from '../../services/customerContract.service';
import './signContract.css';
import SignContractSkeleton from './signContractSkeleton';
import { IContract } from './IContract';
import { v4 as uuid } from 'uuid'
import { useDispatch } from 'react-redux';
import { changeRouteType, getpervInnerState } from '../../redux/handleBackBtn/handleBackBtnSlice';
import { setHeaderTitle } from '../../redux/headerTitle/headerTitleSlice';

const SignContract = ({ setState, referenceKey, setStep }: IContract) => {
    const [disableBtn, setDisableBtn] = useState(false);
    const [otp, setOtp] = useState<string>('');
    const [signTerms, setSignTerms] = useState<string[]>();
    const [otpProperties, setOtpProperties] =
        useState<IRequestSignOtpResponse>();
    const [hasSigned, setHasSigned] = useState<boolean[]>();
    const dispatch = useDispatch()

    const {
        mutate: GetCustomerContractTermsMutate,
        isLoading: customerContractLoading,
    } = useMutation(GetCustomerContractTerms, {
        onSuccess: (data: string[]) => {
            if (data) {
                setSignTerms(data);
                setHasSigned(data?.map(() => false));
            }
        },
        onError: () => { },
    });

    const { mutate: RequestSignOtpMutate } =
        useMutation(RequestSignOtp, {
            onSuccess: (data: IRequestSignOtpResponse) => {
                if (data) {
                    setOtpProperties(data);
                }
            },
            onError: () => { },
        });

    const { mutate: SignContractMutate, isLoading } = useMutation(SignContractOtp, {
        onSuccess: (data: boolean) => {
            if (data) {
                // setState!('accept')
                setStep(uuid())
            }
        },
        onError: () => { },
    });

    const sendOtp = () => {
        SignContractMutate({
            otp: otp,
            referenceKey: referenceKey!,
        });
    };

    useEffect(() => {
        GetCustomerContractTermsMutate({
            referenceKey: referenceKey!,
        });
        RequestSignOtpMutate({
            referenceKey: referenceKey!,
        });
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'viewContract' }));
        dispatch(setHeaderTitle({ header: 'امضای قرارداد', color: 'var(--input-bg-color)', parentRoute: '', }));

    }, []);

    if (customerContractLoading)
        return <SignContractSkeleton />;
    return (
        <div className="container-height-drawer">
            <div className='content-container'>
                <div className='drawer-content'>
                    {/* cards section */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'start',
                            gap: '1rem',
                            marginTop: '1rem',
                            // height: '200px',
                            overflowY: 'auto',
                            marginBottom: '1.7rem',
                            width: '100%',
                        }}
                    >
                        {signTerms?.map((term, index) => (
                            <Box
                                sx={{
                                    backgroundColor: 'var(--input-bg-color)',
                                    padding: '1rem',
                                    borderRadius: '5px',
                                    border: '1px solid var(--border-color)',
                                }}
                            >
                                <FormControlLabel
                                    key={index}
                                    className="contract-formLable"
                                    // required
                                    control={
                                        <Checkbox
                                            onChange={(e) => {
                                                hasSigned![index] = e.target.checked;
                                                setDisableBtn(
                                                    hasSigned!.every((e) => e === true)
                                                );
                                            }}
                                            sx={{
                                                color: 'var(--header-border-color)',
                                                '&.Mui-checked': {
                                                    color: '#BBA57A',
                                                },
                                            }}
                                        />
                                    }
                                    label={
                                        <div className='text-[0.875rem] text-[var(--primary-text-color)]' dangerouslySetInnerHTML={{ __html: term }} />
                                    }
                                />
                            </Box>
                        ))}
                    </Box>
                    {/* otp section */}
                    <Typography
                        sx={{ fontSize: '.9em', color: 'var(--primary-text-color)', marginBottom: '1rem' }}
                    >
                        رمز امضای قراردادی به شماره{' '}
                        {otpProperties?.customerMobileNumber} ارسال شده است.<br />جهت امضای
                        قرارداد رمز را در کادر زیر وارد نمایید.{' '}
                    </Typography>
                    <CustomisedOtpInput
                        numInputs={otpProperties?.otpLength!}
                        otp={otp}
                        setOtp={setOtp}
                        otpTime={otpProperties?.otpLifetime}
                        resendOtp={() =>
                            RequestSignOtpMutate({
                                referenceKey: referenceKey!,
                            })
                        }
                    />
                    {/* sign btn */}
                </div>
                <div className="py-5">
                    <CustomisedButton
                        disable={!disableBtn || otp.length < otpProperties?.otpLength! || isLoading}
                        onClick={sendOtp}
                        title="امضا می‌کنم"
                        type="button"
                    />
                </div>
            </div>

        </div>
    );
};

export default SignContract;
